import { jsx as e } from "react/jsx-runtime";
import "styled-components";
import { useThemeInMode as m } from "../../../context/theme/hooks.js";
import { typographyBodySizeMap as p, typographyBodyLineHeightMap as a } from "../../../styles/typography/typography.js";
import "../../layout/Stack/Stack.js";
import n from "../../layout/Box/Box.js";
import "react";
import "../../../index-CZ8zjHGv.js";
import "../../layout/Center/Center.js";
import "../../../context/WindowSize/Dimensions.js";
import "lodash-es";
import "../../layout/Columns/ColumnsContext.js";
function M(r) {
  const { children: t, dataTest: i } = r, o = m();
  return /* @__PURE__ */ e(
    n,
    {
      color: o["contentOn-error-high-surface"],
      backgroundColor: o["error-high-surface"],
      borderRadius: "small",
      ...p.small,
      ...a.small,
      fontWeight: "bold",
      boxSizing: "content-box",
      padding: "large",
      dataTest: i,
      children: t
    }
  );
}
export {
  M as default
};
